export default "__VITE_ASSET__uQSAr4Gr__"